module.exports = __webpack_public_path__ + "img/63.08244c96.jpg";